import React, { Component } from 'react';
//import consumer_button from '../../img/img-button-Consumer.png';
import consumer_button from '../../img/img-button-Consumer.svg';

class ConsumerButton extends Component {
  render() {
    return (
      <div className="ConsumerButton">
        <a href="https://goo.gl/forms/68rt37pElAEhk3M82" target="_blank" rel="noopener noreferrer"><img id="consumer-button" src={consumer_button} alt={"consumer_button"}/></a>
      </div>
    );
  }
}

export default ConsumerButton;

//<div className="ConsumerButton">
  //<a href="https://goo.gl/forms/68rt37pElAEhk3M82" target="_blank" rel="noopener noreferrer"><img id="consumer-button" src={consumer_button} alt={"consumer_button"}/></a>
//</div>

//<div className="ConsumerButton">
  //<a href="https://t.me/joinchat/UftQDdJtd4e-_uZg" target="_blank" rel="noopener noreferrer"><img id="consumer-button" src={consumer_button} alt={"consumer_button"}/></a>
//</div>